import React from 'react'
import {Textarea, Select} from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel} from 'react-bootstrap'

export default ({reportTypes, submitForm}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          نوع گزارش
        </Col>
        <Col xs={8}>
          <Select
            field="type"
            options={reportTypes}
            placeholder="نوع گزارش"
            className="form-control"
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          توضیحات
        </Col>
        <Col xs={8}>
          <Textarea
            field="context"
            placeholder="توضیحات"
            className="form-control"
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col xsOffset={4} xs={8}>
          <Button type="submit" className="btnBlock" bsStyle="info">
            ثبت گزارش
          </Button>
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseReport/HorseReportForm.js